import { render } from "./createLocationAdmin.vue?vue&type=template&id=3abf4b0f"
import script from "./createLocationAdmin.vue?vue&type=script&lang=js"
export * from "./createLocationAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__